import { PUBLIC_CHANNEL } from 'tools/environments';

export type ClubKey = 'mancity' | 'palermo' | 'newyork';

const DEFAULT_CLUB: ClubKey = 'mancity';

type ClubConfig = {
	/** Short name used for aria labels, footer copyright and image folders. */
	shortName: string;
	/** Full name used as the browser tab title. */
	pageTitle: string;
};

const CLUBS: Record<ClubKey, ClubConfig> = {
	mancity: {
		shortName: 'Manchester City FC',
		pageTitle: 'Manchester City Football Club',
	},
	palermo: {
		shortName: 'Palermo F.C.',
		pageTitle: 'Palermo F.C. | Palermo Calcio Official Website',
	},
	newyork: {
		shortName: 'New York City FC',
		pageTitle: 'New York City FC | Official Website',
	},
};

const isClubKey = (value: string): value is ClubKey => value in CLUBS;

/** The channel this build is themed for, falling back to Manchester City. */
export const CURRENT_CLUB: ClubKey =
	PUBLIC_CHANNEL && isClubKey(PUBLIC_CHANNEL) ? PUBLIC_CHANNEL : DEFAULT_CLUB;

export const getClub = (club: ClubKey = CURRENT_CLUB) => CLUBS[club];

export const getClubImagePath = (file: string, club: ClubKey = CURRENT_CLUB) =>
	`/images/${club}/${file}`;
